﻿import { iconClassName } from "@serenity-is/corelib";

export function AddonTextWithIcon(props: { text: string, icon: string }) {
    const { text, icon } = props;
    return (<>
        {icon && <i class={["addon-icon", iconClassName(icon)]} />}
        <span class={["addon-text", icon && "ms-1"]}>{text}</span>
    </>)
}